import { BASE_PARAMETERS_IMPORT_FIELDS } from '../../../common/constants/base-parameters-import-fields';
import type { XlsxTemplate } from '../../../common/interfaces/xlsx-section';

export const FLEET_XLSX_TEMPLATE: XlsxTemplate = [
  {
    name: 'fleet.fleetForm.generalInformation.heading',
    fields: [
      {
        key: 'category',
        name: 'labels.vehicleCategory',
        required: true,
      },
      {
        key: 'type',
        name: 'labels.vehicleType',
      },
      {
        key: 'registrationNumber',
        name: 'labels.registrationNumber',
        required: true,
      },
      {
        key: 'sideNumber',
        name: 'labels.sideNumber',
      },
      {
        key: 'vinNumber',
        name: 'labels.vinNumber',
        required: true,
      },
      {
        key: 'make',
        name: 'labels.make',
        required: true,
      },
      {
        key: 'model',
        name: 'labels.model',
        required: true,
      },
      {
        key: 'manufactureYear',
        name: 'labels.manufactureYear',
        required: true,
      },
      {
        key: 'firstRegistrationDate',
        name: 'labels.firstRegistrationDate',
        required: true,
      },
      {
        key: 'registrationCountry',
        name: 'labels.registrationCountry',
        required: true,
      },
      {
        key: 'state',
        name: 'labels.state',
        required: true,
      },
      {
        key: 'planningMode',
        name: 'labels.planning',
      },
      {
        key: 'initialMileage',
        name: (translateService) =>
          `${translateService.instant('labels.initialMileage')} [km]`,
      },
      {
        key: 'maxSpeed',
        name: (translateService) =>
          `${translateService.instant('labels.maxSpeed')} [km/h]`,
      },
      {
        key: 'assignedBase',
        name: 'labels.base',
      },
    ],
    required: true,
  },
  {
    name: 'fleet.fleetForm.vehicleMeasurements.heading.vehicle',
    fields: [
      {
        key: 'vehicleCurbWeight',
        name: (translateService) =>
          `${translateService.instant('labels.curbWeight')} [kg]`,
        required: true,
      },
      {
        key: 'vehicleAxleCount',
        name: 'labels.axleCount',
        required: true,
      },
      {
        key: 'vehicleLength',
        name: (translateService) =>
          `${translateService.instant('labels.length')} [m]`,
        required: true,
      },
      {
        key: 'vehicleWidth',
        name: (translateService) =>
          `${translateService.instant('labels.width')} [m]`,
        required: true,
      },
      {
        key: 'vehicleHeight',
        name: (translateService) =>
          `${translateService.instant('labels.height')} [m]`,
        required: true,
      },
    ],
    required: true,
  },
  {
    name: 'fleet.fleetForm.cargoSpace.heading.default',
    fields: [
      {
        key: 'loadCapacity',
        name: (translateService) =>
          `${translateService.instant('labels.loadCapacity')} [kg]`,
        required: true,
      },
      {
        key: 'volumeCapacity',
        name: (translateService) =>
          `${translateService.instant('labels.volumeCapacity')} [m³]`,
      },
      {
        key: 'chambersNumber',
        name: 'labels.chambersNumber',
      },
      {
        key: 'tankCertificates',
        name: 'labels.tankCertificates',
      },
      {
        key: 'dischargeTypes',
        name: 'labels.dischargeType',
      },
      {
        key: 'europalletsNumber',
        name: 'labels.europalletsNumber',
      },
      {
        key: 'cargoSpaceLength',
        name: (translateService) =>
          `${translateService.instant('labels.length')} [m]`,
      },
      {
        key: 'cargoSpaceWidth',
        name: (translateService) =>
          `${translateService.instant('labels.width')} [m]`,
      },
      {
        key: 'cargoSpaceHeight',
        name: (translateService) =>
          `${translateService.instant('labels.height')} [m]`,
      },
    ],
  },
  {
    name: 'fleet.fleetForm.fuelTankCapacity.heading',
    fields: [
      {
        key: 'mainTank',
        name: (translateService) =>
          `${translateService.instant('labels.mainTank')} [L/kg/kWh]`,
      },
      {
        key: 'fuelType',
        name: 'labels.fuelType',
      },
      {
        key: 'additionalTank',
        name: (translateService) =>
          `${translateService.instant('labels.additionalTank')} [L/kg/kWh]`,
      },
      {
        key: 'adBlueTank',
        name: (translateService) =>
          `${translateService.instant('labels.adBlue')} [L]`,
      },
      {
        key: 'generatorFuelTank',
        name: (translateService) =>
          `${translateService.instant('labels.generatorFuelTank')} [L]`,
      },
    ],
  },
  {
    name: 'fleet.fleetForm.ownership.heading',
    fields: [
      {
        key: 'isForSale',
        name: (translateService) =>
          `${translateService.instant('labels.forSale')}?`,
        required: true,
      },
      {
        key: 'ownershipType',
        name: 'labels.ownershipType',
        required: true,
      },
      {
        key: 'vehicleValue',
        name: 'labels.vehicleValue',
      },
      {
        key: 'vehicleValueCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.vehicleValue')} (${translateService.instant('labels.currency').toLowerCase()})`,
      },
      {
        key: 'depreciationPeriodFrom',
        name: (translateService) =>
          `${translateService.instant('labels.depreciationPeriod')} (${translateService.instant('labels.from').toLowerCase()})`,
      },
      {
        key: 'depreciationPeriodTo',
        name: (translateService) =>
          `${translateService.instant('labels.depreciationPeriod')} (${translateService.instant('labels.to').toLowerCase()})`,
      },
      {
        key: 'selfDeposit',
        name: 'labels.selfDeposit',
      },
      {
        key: 'selfDepositCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.selfDeposit')} (${translateService.instant('labels.currency').toLowerCase()})`,
      },
      {
        key: 'buyout',
        name: 'labels.buyout',
      },
      {
        key: 'buyoutCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.buyout')} (${translateService.instant('labels.currency').toLowerCase()})`,
      },
      {
        key: 'installment',
        name: 'labels.installment',
      },
      {
        key: 'installmentCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.installment')} (${translateService.instant('labels.currency').toLowerCase()})`,
      },
      {
        key: 'firstInstallmentDate',
        name: 'labels.firstInstallment',
      },
      {
        key: 'lastInstallmentDate',
        name: 'labels.lastInstallment',
      },
      {
        key: 'margin',
        name: (translateService) =>
          `${translateService.instant('labels.margin')} [%]`,
      },
      {
        key: 'interestRateType',
        name: 'labels.interestRate',
      },
    ],
    required: true,
  },
  {
    name: 'fleet.fleetForm.licensesAndPermits.heading',
    fields: [
      {
        key: 'issuingCountry',
        name: 'labels.issuingCountry',
        required: true,
      },
      {
        key: 'communityLicenseAbstractNumber',
        name: 'labels.communityLicenseAbstract',
      },
      {
        key: 'permitAbstractNumber',
        name: 'labels.permitAbstract',
      },
    ],
  },
  {
    name: 'forms.countriesWhitelist.heading',
    fields: [
      {
        key: 'countriesGroup',
        name: 'forms.countriesWhitelist.group',
      },
      {
        key: 'countriesWhitelist',
        name: 'forms.countriesWhitelist.whitelist',
      },
    ],
    required: true,
  },
  {
    name: 'labels.note',
    fields: [
      {
        key: 'note',
        name: 'labels.note',
      },
    ],
  },
  {
    name: 'forms.parameters.heading',
    fields: [
      {
        key: 'isLowDeck',
        name: (translateService) =>
          `${translateService.instant('labels.lowDeck')}?`,
      },
      {
        key: 'semiTrailerSize',
        name: 'labels.semiTrailerSize',
      },
      {
        key: 'trailerSize',
        name: 'labels.trailerSize',
      },
      {
        key: 'coilWellLength',
        name: (translateService) =>
          `${translateService.instant('labels.coilWell')} (${translateService.instant('labels.length').toLowerCase()})`,
      },
      ...BASE_PARAMETERS_IMPORT_FIELDS,
    ],
    required: true,
  },
  {
    name: 'fleet.fleetForm.tachograph.heading',
    fields: [
      {
        key: 'tachographModel',
        name: 'labels.model',
        required: true,
      },
      {
        key: 'tachographMake',
        name: 'labels.producent',
        required: true,
      },
      {
        key: 'tachographNextLegalizationDate',
        name: 'labels.nextLegalizationDate',
        required: true,
      },
    ],
  },
  {
    name: 'fleet.fleetForm.registrationCertificate.heading',
    fields: [
      {
        key: 'technicalInspectionExpiryDate',
        name: 'labels.technicalInspectionExpiryDate',
        required: true,
      },
    ],
    required: true,
  },
  {
    name: 'fleet.fleetForm.co2Emissions.heading',
    fields: [
      {
        key: 'emissionStandard',
        name: 'labels.emissionStandard',
        required: true,
      },
    ],
  },
  {
    name: 'fleet.fleetForm.insurance.heading.thirdPartyLiability',
    fields: [
      {
        key: 'thirdPartyLiabilityInsuranceNumber',
        name: 'labels.insuranceNumber',
      },
      {
        key: 'thirdPartyLiabilityExpiryDate',
        name: 'labels.expirationDate',
        required: true,
      },
      {
        key: 'thirdPartyLiabilityAnnualCost',
        name: 'labels.annualCost',
        required: true,
      },
      {
        key: 'thirdPartyLiabilityAnnualCostCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.annualCost')} (${translateService.instant('labels.currency').toLowerCase()})`,
        required: true,
      },
      {
        key: 'thirdPartyLiabilityInsuranceSum',
        name: 'labels.insuranceSum',
      },
      {
        key: 'thirdPartyLiabilityInsuranceSumCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.insuranceSum')} (${translateService.instant('labels.currency').toLowerCase()})`,
      },
    ],
    required: true,
  },
  {
    name: 'fleet.fleetForm.insurance.heading.comprehensive',
    fields: [
      {
        key: 'comprehensiveInsuranceNumber',
        name: 'labels.insuranceNumber',
      },
      {
        key: 'comprehensiveExpiryDate',
        name: 'labels.expirationDate',
        required: true,
      },
      {
        key: 'comprehensiveAnnualCost',
        name: 'labels.annualCost',
        required: true,
      },
      {
        key: 'comprehensiveAnnualCostCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.annualCost')} (${translateService.instant('labels.currency').toLowerCase()})`,
        required: true,
      },
      {
        key: 'comprehensiveInsuranceSum',
        name: 'labels.insuranceSum',
      },
      {
        key: 'comprehensiveInsuranceSumCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.insuranceSum')} (${translateService.instant('labels.currency').toLowerCase()})`,
      },
    ],
  },
];
